// @flow
import * as React from 'react';
import * as ReactIs from 'react-is';

import { RSLWorkedQuestion } from './retrofitted-student-lesson/RSLWorkedQuestion.js';
import { RSLTNTeacherLedExample } from './retrofitted-student-lesson-teacher-note/RSLTNTeacherLedExamples.js';

export function numWorkedQuestions(node: React$Element<any>) {
  let count = 0;
  traverseElementTree(node, (element) => {
    const component = getComponent(element);
    if (component === RSLWorkedQuestion) count += 1;
  });
  return count;
}

export function numTeacherLedExamples(node: React$Element<any>) {
  let count = 0;
  traverseElementTree(node, (element) => {
    const component = getComponent(element);
    if (component === RSLTNTeacherLedExample) count += 1;
  });
  return count;
}

function traverseElementTree(
  node: React$Node,
  visit: (node: React$Element<any>) => void,
) {
  // We are not interested in visiting leaf nodes which are not elements
  if (ReactIs.isElement(node) === false) return;

  // Manual coercion for Flow since it doesn't know what type ReactIs.isElement enforces.
  const element: React$Element<
    (props: { [key: string]: any, children?: React$Node }) => React$Node,
  > = (node: any);

  visit(element);

  React.Children.forEach(element.props.children, (node) =>
    traverseElementTree(node, visit),
  );
}

// We have this annoying pattern for the CartesianPlane components
// where we wrap the actual component in a HoC. Once we roll out
// the new validation scheme we'll be able to unwind those HoCs
// and then unwind this function.
function getComponent(element: React$Element<any>) {
  return element.type.__wrappedComponent ?? element.type;
}
